export const ff = 'Pretendard, sans-serif';

export const C = {
  bk: '#090909', white: '#FFFFFF', bg: '#FCFCFD',
  g200: '#E9E9EC', g300: '#A9A9B2', g400: '#888896', g500: '#555555',
  sub: '#A2A2A2', point: '#FFD92B', orange: '#FFA40D',
  green: '#10B981', blue: '#3B82F6', purple: '#8B5CF6', yellow: '#FFEF42',
  shadow: '2px 2px 10px rgba(0,0,0,0.08)',
};

export const t = (size, w, color, extra = {}) => ({
  fontFamily: ff,
  fontSize: size,
  fontWeight: w,
  letterSpacing: '-0.04em',
  color,
  lineHeight: '140%',
  ...extra,
});
